<i18n src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/package_group_card.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div :class="['flex justify-between h-[10rem]', rounded_class]">
    <div
      class="md:flex items-center justify-between leading-tight min-w-[80%] md:min-w-[90%]"
    >
      <div class="pl-2">
        <h3 class="text-lg flex">
          <div
            :href="package_group.href"
            class="font-medium focus:outline-none truncate"
          >
            {{ package_group.pg_code }}
          </div>
          <div v-if="package_group.thermo_code" class="text-gray-500 ml-2">
            {{ package_group.thermo_code }}
          </div>
        </h3>
        <div class="text-sm">
          {{ getProducerLabel(package_group) }}
        </div>
      </div>
      <div class="text-grey-darker text-sm">
        <div>
          {{ getQuantityLabel(package_group) }}
        </div>
        <div v-if="package_group.exporter_process_brand">
          {{ $t("model.package_group.exporter_process_brand_id") }}
          {{ package_group.exporter_process_brand.agro_exporter_brand.name }}
        </div>
        <div v-if="package_group.exporter_process_crop_category">
          {{
            $t(
              "model.package_group.exporter_process_crop_category_id_abbreviation"
            )
          }}
          {{
            package_group.exporter_process_crop_category
              .agro_exporter_crop_category.crop_category.name
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    package_group: {
      type: Object,
      required: true,
    },
    rounded_class: {
      type: String,
      default: "",
    },
  },
  components: {},
  computed: {},
  methods: {
    getProducerLabel: function (package_group) {
      return package_group.packages
        .map((package_item) => this.getProducerLabelByPackage(package_item))
        .join(", ");
    },
    getProducerLabelByPackage: function (package_item) {
      let org_name = null;
      if (package_item.organization) org_name = package_item.organization.name;
      if (package_item.producer) {
        let producer_name = package_item.producer.name;
        if (org_name) return `${producer_name} (${org_name})`;
        return producer_name;
      } else if (org_name) {
        return org_name;
      }
      return "";
    },
    getQuantityLabel: function (package_group) {
      return package_group.total_packages_with_labels_data
        .map((package_type) =>
          this.$t("model.package_group.package_quantity", package_type)
        )
        .join(", ");
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: min-content;
  background-color: black;
  color: #fff;
  text-align: right;
  border-radius: 6px;
  padding: 5px 10px;
  margin-top: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
